import { Component, Input } from '@angular/core';

import { PhcThumbnail } from "../../classes/phc-app/phc-app";

import { IonicIcons } from '../../classes/shared/constants';


/**
 * Generated class for the PhcMenuCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'phc-menu-card',
  templateUrl: 'phc-menu-card.html'
})
export class PhcMenuCardComponent {

  @Input()
  thumbnail: PhcThumbnail;

  @Input()
  title = '';

  @Input()
  icon = '';

  @Input()
  description = '';


  cardId = `card-title-${Date.now().toString()}`;

  constructor() {

  }

  titleParts(){
    return this.title.split(' ');
  }

  largestPart(){
    return this.titleParts().reduce((prev, curr) => {
      if(curr.length > prev.length){
        return curr;
      }
      return prev;
    }, '');
  }

  ngOnChanges(){
    if (!IonicIcons.isIcon(this.icon)) {
      this.icon = '';
    }
  }

  ngAfterViewInit(){
    /*
    const largestWordInd = this.titleParts().indexOf(this.largestPart());
    const largestWord = document.querySelectorAll(`#${this.cardId} .card-title-word`)[largestWordInd];
    const card = document.querySelector(`#${this.cardId}`);
    let wordWidth = largestWord.getBoundingClientRect().width;
    let cardWidth = card.getBoundingClientRect().width;

    if(wordWidth > (cardWidth*0.75)){
      console.log('update ' + this.titleParts()[largestWordInd]);
    }
    */
    /*
    if (this.title.length){
      (<any>window).fitText(document.querySelector(`#${this.cardId} .card-title h1`), 0.75);
    }
    */
  }

}



// WEBPACK FOOTER //
// ./src/components/phc-menu-card/phc-menu-card.ts